<template lang="html">
  <div class="rules-wrapper-background">
    <div class="rules-wrapper">
      <table>
        <thead>
          <tr>
            <td></td>
            <td>{{$t('main.documentName')}}</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(doc, index) in documents" :key="index">
            <td>
              <div class="icon-wrapper">
                <img v-if="doc.doc_priority === 2" src="@/assets/icons/importantDocument.png" alt="preview icon">
              </div>
            </td>
            <td>{{doc.doc_name}}</td>
            <td v-if="doc.doc_type !== 'DOC'">
              <a class="link" :href="generatePreviewLink(doc)" target="_blank">
                <div class="icon-wrapper">
                  <img src="@/assets/icons/previewDocument.png" alt="preview icon">
                </div>
              </a>
            </td>
            <td v-else></td>
            <td>
              <a class="link" :href="generateDownloadLink(doc)">
                <div class="icon-wrapper">
                  <img src="@/assets/icons/downloadDocument.png" alt="preview icon">
                </div>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { api, baseURL } from '@/api'
export default {
  name: 'Rules',
  data () {
    return {
      documents: []
    }
  },
  mounted () {
    this.fetchRules()
  },
  methods: {
    fetchRules () {
      api.fetchRules().then(res => {
        console.log(res)
        this.documents = res.data.data
      }).catch(e => {
        console.log(e)
      })
    },
    generatePreviewLink (doc) {
      return baseURL + `/documents/${doc.doc_id}/document`
    },
    generateDownloadLink (doc) {
      return baseURL + `/documents/${doc.doc_id}/download`
    }
  },
  watch: {
    '$i18n.locale': {
      handler (newLocale, oldLocale) {
        if (newLocale !== oldLocale) {
          this.fetchRules()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rules-wrapper-background {
  background: #F2F2F2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .rules-wrapper {
    display: flex;
    height: 100%;
    max-width: 1600px;
    width: calc( 100% - 40px );
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    justify-content: center;

    table {
      border: 1px solid #E8E8E8;
      width: 100%;
      max-width: 1020px;
      border-collapse: collapse;

      thead {
        td {
          padding: 5px;
          box-sizing: border-box;
          text-align: left;
          height: 65px;
          border-bottom: 1px solid #E8E8E8;
          font-weight: 800;
          font-size: 15px;
          line-height: 24px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          text-transform: uppercase;
        }
      }
      tbody {
        tr {
          td {
            padding: 5px;
            box-sizing: border-box;
            text-align: left;
            height: 60px;
            border-bottom: 1px solid #E8E8E8;
            font-weight: 600;
            font-size: 15px;
            line-height: 25px;
            letter-spacing: 0.06em;
            color: #606060;

            .icon-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
          }
        }
        tr:last-child {
          td {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
